import React from 'react'
import './Hero.css'
import PrimaryButtons from '../../components/buttons/Buttons'
const Hero = () => {
  return (
    <div className='hero-main'>

    <div className='hero-text'>
        <h6 className='hero-sub'>welcome to CYBORG website by Walaa</h6>
        <h4 className='hero-title'><em>browse</em> our popular gamers </h4>
        <PrimaryButtons>browse here</PrimaryButtons>
      
    </div>
    </div>
  )
}

export default Hero